
export const Config =
{
    useFakeGpsProvider:  false,
    alwaysShowGpsWarning: false,
    allowDeviceFilterBypass: false
};